import { z } from "zod"

// null means the store doesn't limit how many cargo bikes can be booked per day
export const CargoBikeLimitSchema = z.object({
  maxCargoBikesPerDay: z.number().int().min(1).nullable(),
})

export type CargoBikeLimit = z.infer<typeof CargoBikeLimitSchema>
